// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2G8Yy","file":"styles_file__3RLHG"};